import Navbar from "../../components/Navbar/Navbar"
import React from "react";
import Hero from "./Hero";
import ImpactStat from "./ImpactStat";
import Vision from "./Vision";
import WhatWeDoHome from "./WhatWeDo";
import OurStory from "./OurStory;";
import Donation from "./Donate";
import Team from "./Team";
import Contact from "./Contact";
import Footer from "../../components/Footer/Footer";
import StickyBottomNav from "../../components/Navbar/StickyBottomNav";

export default function Home() {

  return (
    <div className="bg-offWhite">
      <section className="bg-lightTeal min-h-screen">
        <Navbar />
        <div className="relative bg-lightTeal min-h-screen overflow-hidden">
          <Hero />
        </div>
      </section>

      <section>
        <ImpactStat />
        <Vision />
        <WhatWeDoHome />
        <OurStory />
        {/* <Donation /> */}
        <Team />
        <Contact />
        <Footer />
        <StickyBottomNav />
      </section>
    </div>
  );
}
